import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withHeaderBackgroundProps from 'components/withHeaderBackgroundProps';
import { sectionHeaderPropTypes } from 'config/sectionHeader/sectionHeaderPropTypes';

import { calculateHeaderBackgroundStyles } from 'utils/headerBackgroundUtils';
import toPx from 'utils/toPx';
import headerBackgroundDefaultCoords from 'config/sectionHeader/headerBackgroundDefaultCoords';
import {
  LOGO,
  LOGO_WITH_TEXT,
  TEXT,
} from '../../headerCustomizer/constants/headerLayoutPresets';
import HeaderLogoContent from '../../headerCustomizer/HeaderLogoContent';
import HeaderTextContent from '../../headerCustomizer/HeaderTextContent';
import HeaderLogoWithTextContent from '../../headerCustomizer/HeaderLogoWithTextContent';

import styles from './SectionHeader.scss';

class SectionHeader extends Component {
  static propTypes = {
    ...sectionHeaderPropTypes,
    backgroundImageClassName: PropTypes.string,
    isEditMode: PropTypes.bool,
  };

  static defaultProps = {
    // `isHeaderFullWidth` is null by default to recalculate styles when it takes boolean from redux store @sinslav
    isHeaderFullWidth: null,
    backgroundCoords: headerBackgroundDefaultCoords,
    backgroundImageClassName: '',
  };

  renderPlaceholder = () => (
    <div
      className={styles.placeholder}
      style={{ height: toPx(this.props.height) }}
    >
      <span className={styles.text}>Header</span>
    </div>
  );

  renderLayout = () => {
    const {
      isEditMode,
      logoImageUrl,
      logoImageAlign,
      logoImageLinkUrl,
      logoImageSize,
      logoImageSizePreset,
      containerSize,
      layout,
      clientUuid,
      textContent,
      logoWithTextAlign,
    } = this.props;

    switch (layout) {
      case LOGO:
        return (
          <HeaderLogoContent
            isEditMode={isEditMode}
            logoImageUrl={logoImageUrl}
            logoImageLinkUrl={logoImageLinkUrl}
            logoImageAlign={logoImageAlign}
            logoImageSizePreset={logoImageSizePreset}
            logoImageSize={logoImageSize}
            containerSize={containerSize}
          />
        );
      case TEXT:
        return (
          <HeaderTextContent
            isEditMode={isEditMode}
            clientUuid={clientUuid}
            textContent={textContent}
          />
        );
      case LOGO_WITH_TEXT:
        return (
          <HeaderLogoWithTextContent
            isEditMode={isEditMode}
            logoImageUrl={logoImageUrl}
            logoImageLinkUrl={logoImageLinkUrl}
            logoImageAlign={logoImageAlign}
            logoImageSizePreset={logoImageSizePreset}
            logoImageSize={logoImageSize}
            containerSize={containerSize}
            clientUuid={clientUuid}
            textContent={textContent}
            logoWithTextAlign={logoWithTextAlign}
          />
        );
      default:
        return null;
    }
  };

  getHeaderBackgroundStyles = () => {
    const {
      backgroundCoords,
      backgroundImageSize: bgSize,
      imageMoveDirection,
      containerSize,
      imgSize,
    } = this.props;

    return calculateHeaderBackgroundStyles(
      bgSize,
      imageMoveDirection,
      containerSize,
      imgSize,
      backgroundCoords,
    );
  };

  renderBackgroundImage = () => {
    const { backgroundImageUrl, backgroundImageClassName } = this.props;

    return (
      <div
        className={cx(styles.backgroundImage, backgroundImageClassName)}
        data-e2e="header-background-image"
        style={{
          backgroundImage: `url(${backgroundImageUrl})`,
          ...this.getHeaderBackgroundStyles(),
        }}
      />
    );
  };

  renderContent = () => {
    const { isPlaceholder, isContentEnabled, backgroundImageUrl } = this.props;

    if (isPlaceholder) {
      return this.renderPlaceholder();
    }

    return (
      <div className={styles.imageContainer}>
        {backgroundImageUrl && this.renderBackgroundImage()}
        {isContentEnabled && this.renderLayout()}
      </div>
    );
  };

  render = () => {
    const { containerClassName, height, backgroundColor } = this.props;
    return (
      <div
        className={cx(styles.container, containerClassName)}
        style={{
          height: toPx(height),
          backgroundColor,
        }}
        data-e2e="editor-section-header-container"
      >
        {this.renderContent()}
      </div>
    );
  };
}

export default withHeaderBackgroundProps(SectionHeader); // @TODO #005 Remove redundant HOC @sinslav
